<div class="modal-body">
    <p>
        <i class="pi pi-exclamation-triangle"></i>
        &nbsp;确定要通过质检吗?
    </p>

    <div>
        <p-messages severity="info" class="mb-2">
            <ng-template pTemplate>
                <div class="ml-2">请判定本次重新设计原因</div>
            </ng-template>
        </p-messages>
        <app-design-revision-judgement-edit
            [treatmentTypeId]="config?.treatmentTypeId"
            [form]="designRevisionJudgementForm"
        />
    </div>
</div>

<div class="d-flex justify-content-end gap-2 mt-3">
    <p-button
        label="取消"
        (onClick)="onCancel()"
        [text]="true"
        styleClass="p-button-text p-button-secondary"
    />
    <p-button
        label="确定"
        [disabled]="designRevisionJudgementForm?.invalid"
        (onClick)="onConfirm()"
        [text]="true"
        severity="success"
    />
</div>
